import { render, staticRenderFns } from "./ChooseTransition.vue?vue&type=template&id=3d144598&scoped=true&"
import script from "./ChooseTransition.vue?vue&type=script&lang=js&"
export * from "./ChooseTransition.vue?vue&type=script&lang=js&"
import style0 from "./ChooseTransition.vue?vue&type=style&index=0&id=3d144598&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d144598",
  null
  
)

export default component.exports